import React, { useState } from "react";
import { Col, Row, message, Modal, Collapse, Select, Card, Button, Carousel } from "antd";
import {
  DownloadOutlined,
  FileExcelOutlined,
  MailOutlined,
  MessageOutlined,
  FileDoneOutlined,
  PrinterOutlined,
  DollarOutlined,
  UserOutlined,
  PhoneOutlined,
  QrcodeOutlined,
  IdcardOutlined,
  NumberOutlined,
  DollarCircleFilled,
  DollarTwoTone,
  CheckCircleOutlined,
  BellOutlined,
  CloseCircleOutlined,
  StopOutlined,
  MoneyCollectOutlined
} from "@ant-design/icons";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { formatDate, DISPLAY_FORMAT } from "../../../helpers/dateHelper";
import parse from "html-react-parser";
import { getAllActivitiesPrice } from "../../../pages/Activitespkg/Activitiescheckout/activitiesHelper";
import { QRCodeSVG as QRCode } from "qrcode.react";
import ApiClient from "../../../helpers/ApiClient";
import Table from "react-bootstrap/Table";
import { useAuthContext } from "../../providers/AuthProvider";
import { useCurrencyContext } from "../../providers/CurrencyProvider";
import "../ticketActivities.scss";
import "./TicketScreen.scss";
import "../../../components/Travelitinerary/Travelitinerary.scss";

dayjs.extend(customParseFormat);
const { Panel } = Collapse;
const { Option } = Select;
const { confirm } = Modal;

const NewTicketActivites = ({ ticketData, cmsFareRules, voucherData,showTicketPolicyBottom}) => {
  const {
    isLogin: { agent },
  } = useAuthContext();
  const { totalAmount, discount } = getAllActivitiesPrice(
    ticketData.TourDetails,
    ticketData.convienenceData,
    ticketData.promoData
  );
  const [CancellationPolicyModal, setCancellationPolicyModal] = useState(false);
  const [CancellationPolicy, setCancellationPolicy] = useState([]);
  const [QrCodeIndex, setQrCodeIndex] = useState(0);
  const [QrCodeDetails, setQrCodeDetails] = useState({ tour: {}, tourIndex: 0 });
  const [isVisible, setIsVisible] = useState(false);
  const { activeCurrency, currencyValue } = useCurrencyContext();
  const [pdfModalVisible, setPdfModalVisible] = useState(false);
  const getStatus = (status) => {
    switch (status) {
      case 2: {
        return <span style={{ color: "#FFA500" }} className="border p-2 rounded">BLOCKED <StopOutlined /> </span>;
      }

      case 1: {
        return (
          <span style={{ color: "#008000" }} className="border p-2 rounded">
            <b> CREATED </b>
          </span>
        );
      }

      case 3: {
        return (
          <span style={{ color: "#008000" }} className="border p-2 rounded">
            <b> CONFIRMED <CheckCircleOutlined /> </b>
          </span>
        );

      }
      case 6: {
        return (
          <span style={{ color: "#FF0000" }} className="border p-2 rounded">
            <b> CANCELLED <CloseCircleOutlined /></b>
          </span>
        );
      }

      case 11: {
        return (
          <span style={{ color: "#FF0000" }} className="border p-2 rounded">
            <b> VOUCHERED <QrcodeOutlined /> </b>
          </span>
        );
      }
      case 7: {
        return (
          <span style={{ color: "#FF0000" }} className="border p-2 rounded">
            <b> On Request <BellOutlined /> </b>
          </span>
        );
      }

      default:
        return;
    }
  };

  const getPaxCount = (pax) => {
    return `Adult(s) ${pax?.adults !== "0" ? pax?.adults : 0} ${pax?.childCount !== "0" ? ", Child(s) " + pax?.childCount : " "
      } ${pax?.infantCount !== "0" ? ", Infant(s) " + pax?.infantCount : " "}`;
  };

  const getTotalAmount = () => {
    let postMarkup = ticketData.totalPostMarkup
      ? ticketData.totalPostMarkup
      : 0;
    let totalAmount =
      Number(ticketData.PartPayment.serviceTotal) + Number(postMarkup);

    return Number(totalAmount).toFixed(2);
  };

  const getTicketPolicy = (tour) => {
    let { tourId, journeyDate, startTime, serviceUniqueId, optionId } = tour;
    if (
      tour.apikey === "EXT" &&
      (!tour?.CancellationPolicy || tour.CancellationPolicy.length === 0)
    ) {
      // EXT API and no cancellation policy, open PDF
      // window.open("/EXTPolicy/IMPORTANT%20NOTE.pdf", "_blank");
      setPdfModalVisible(true);
      return;
    }
    setCancellationPolicyModal(true)
    setCancellationPolicy(tour?.ticketPolicy)
  }

  const toggleCancelHandler = () => {
    setCancellationPolicyModal((prev) => !prev);
  };

  const getImporatntNote = (tour) => {
    const { bookingStatus, apikey, transferName } = tour;

    switch (bookingStatus) {
      case 3:
        return apikey === "EXT" && transferName.includes("Private Transfer")
          ? <p className="font-weight-bold m-0"><span className="text-danger">Note :-</span> Don't forget to voucher your transfer. If you do not voucher this transfer, it will be cancelled automatically.</p>
          : <p className="font-weight-bold m-0"><span className="text-danger">Note :-</span> Please do Vouchered Your Tickets</p>;

      case 11:
        return apikey !== "EXT" ? (
          <p className="font-weight-bold m-0"><span className="text-danger">Note :-</span>{" "}
            The QR code will be shared once it becomes available. For any assistance, please contact the emergency number <strong>011-49511313</strong>. Thank you for your cooperation.
          </p>
        ) : null;

      case 7:
        return <p className="font-weight-bold m-0"><span className="text-danger">Note :-</span> Your booking is being processed, but confirmation is pending. Our team will contact you shortly.</p>;

      default:
        return null;
    }
  };

  const handleOnChange = (val) => {
    setQrCodeIndex(val);
  }

  /**  Comment displayAllQrCode 
  const displayAllQrCode = (tour, key) => {
    confirm({
      title: 'ALL Qr Code Genrated',
      icon: <QrcodeOutlined />,
      content: (
        <React.Fragment>
          <Row>
            <Col md={12} className="my-3" key={key}>
              <Select style={{ width: 300 }} onChange={handleOnChange} defaultValue={QrCodeIndex}>
              {[...Array(tour.ticket.length)].map((_, count) => (
                <Option key={"QrCode" + count} value={count} > {count + 1}</Option>
              ))}
              </Select>
            </Col>
          </Row>
          <Row>
            <Col className="my-3 mx-auto" md={12} key={key}>
              <QRCode
                value={tour.ticket[QrCodeIndex].barcode}
                size={100}
                title={tour.tourName}
                id={"packageQR" + key + "" + QrCodeIndex}
              />
            </Col>
          </Row>
        </React.Fragment>
      ),
      onOk() {
        console.log('OK');
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };*/

  const displayAllQrCode = (tour, key) => {
    setIsVisible(true)
    setQrCodeDetails({ tour: tour, tourIndex: key })
  }

  const handleOkQRModal = () => {
    setIsVisible(false);
  }

  return (
    <div className="activities-ticket">
      <h6 className="font-weight-bold">Activity Tickets</h6>
      <div class="card border" role="alert">
        <div className="pax-info-header mb-3 mx-1">
          <h6 className="pax-title">Passanger Details</h6>
          <div className="subinfo">
            <div className="user_name mb-2 text-dark d-flex justify-content-between">
              <div className="sub-title">
                <b><UserOutlined />Guest Name : </b>
                <span>
                  {ticketData?.Passengers?.prefix}{" "}
                  {ticketData?.Passengers?.firstName}{" "}
                  {ticketData?.Passengers?.lastName}
                </span>
              </div>
              <div className="sub-title">
                <b><MailOutlined />Email : </b>
                <span>{ticketData?.Passengers?.email}</span>
              </div>
            </div>
            <div className="user_name text-dark d-flex justify-content-between">
              <div className="sub-title">
                <b><PhoneOutlined rotate={100} />Contact : </b>
                <span>{ticketData?.Passengers.mobile}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="pax-info-header mx-1">
          <h6 className="pax-title">Transfer Details</h6>
          <div className="subinfo">
            <div className="user_name mb-2 text-dark d-flex justify-content-between">
              <div className="sub-title">
                <b><NumberOutlined />Booking ID : </b>
                <span>{ticketData?.TourDetails?.[0].referenceNumber}</span>
              </div>
              <div className="sub-title">
                <b><DollarOutlined /> Total Amount : </b>
                <span> {activeCurrency} {currencyValue(totalAmount)}</span>
              </div>
            </div>
            <div className="user_name text-dark d-flex justify-content-between">
              <div className="sub-title">
                <b><DollarOutlined />Final Amount : </b>
              </div>
              <div className="sub-title">
                <span>{activeCurrency} {currencyValue(getTotalAmount())}</span>
              </div>
            </div>
            {ticketData?.Passengers?.specialReq != '' && (
              <div className="sub-title mt-2">
                <div class="alert" role="alert" style={{ background: "linear-gradient(15deg, #76898f63, transparent)" }}>
                  <b><FileDoneOutlined />Special Request : </b>
                  {ticketData?.Passengers?.specialReq}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {ticketData?.TourDetails?.map((tour, index) => (
        <div class="card border" role="alert">
          <div className="ticket-details mx-1 py-1">
            <div className="ticket_header d-flex justify-content-between">
              <h6 className="pax-title">{tour?.tourName}</h6>
              {/* <h6 className="pax-title">{formatDate(tour.journeyDate, "DD MMM YYYY")}</h6> */}
            </div> <div className="sub-title">{tour.optionName}</div>
            <Row className="justify-content-between my-2" style={{height:"165px"}}>
              <Col md={8} xs={24}>
                <img style={{ objectFit: "cover", height: "155px" }} className="hotel-tag-1" src={tour.tourImage} alt="First slide" />
              </Col>
              {tour.hasOwnProperty('ticket') && tour.ticket.length > 1 && tour.bookingStatus === 11 ? (
                <div className="font-weight-bold m-0"><span className="text-danger">Note :-</span> Please Download Vouchered Tickets for saperate Baar Code
                </div>
              ) : null}
              {tour.hasOwnProperty('ticket') && tour.ticket.length == 1 ? (
                <Col md={4} xs={24} className="">
                  {tour.hasOwnProperty('ticket') && tour.ticket.length > 0 && (
                    <React.Fragment>
                      {tour.ticket.map((x, i) => (
                        <QRCode
                          value={x.barcode}
                          size={100}
                          title={tour.tourName}
                          id={"packageQR" + index + "" + i}
                        />
                      ))}
                    </React.Fragment>
                  )}
                </Col>
              ) : tour.hasOwnProperty('ticket') && tour.ticket.length > 1 ? (
                <Col md={{ span: 5, offset: 19 }} xs={24} style={{ position: 'relative', textAlign: 'center', top:"-150px" }}>
                  {/* <Button onClick={() => displayAllQrCode(tour, index)} style={{ position: 'absolute', bottom: '0%', left: '430%', transform: 'translate(-50%, -50%)', fontSize: '14px', color: 'black', textShadow: '1px 1px 2px rgba(248, 248, 247, 0.2)' }}>Show All QR Code </Button> */}
                  {/* {tour.ticket.map((x, i) => (
                        <QRCode
                          value={x.barcode}
                          size={100}
                          title={tour.tourName}
                          id={"packageQR" + index + "" + i}
                        />
                      ))} */}
                  <Carousel className="car-barcode-act"
                    // dots={{ className: "custom-dots" }} 
                    dots={false}
                    arrows={true}
                    infinite={false}
                    prevArrow={<div className="custom-prev-arrow"></div>}
                    nextArrow={<div className="custom-next-arrow"></div>}
                  >
                    {tour.ticket.map((x, i) => (
                      <div className="div-car-bar" key={i} style={{ display: "flex", justifyContent: "center" }}>
                        <QRCode
                          value={x.barcode}
                          size={100}
                          title={tour.tourName}
                          id={"packageQR" + index + "" + i}
                        />
                      </div>
                    ))}
                  </Carousel>
                </Col>
              ) : !(tour?.apikey == 'EXT') && (
                <Col md={5} xs={24} style={{ position: 'relative', textAlign: 'center' }}>
                  <QrcodeOutlined style={{ fontSize: '140px', filter: 'blur(3px)', opacity: '0.2' }} />
                  <span style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', fontSize: '14px', color: 'black', textShadow: '1px 1px 2px rgba(248, 248, 247, 0.2)' }}>QR Code not Generated</span>
                </Col>
              )}
            </Row>
            {getImporatntNote(tour) != null && ([3, 11, 7].includes(tour.bookingStatus) && (!tour.hasOwnProperty('ticket') || tour.ticket.length == 0)) && (
              <div class="alert" role="alert" style={{ background: "linear-gradient(6deg, #f1e67b, transparent)" }}>
                {getImporatntNote(tour)}
              </div>
            )}
            {tour.tourShortDescription != '' && (
              <div class="alert alert-info" role="alert">
                <p className="hotel-list-para"
                  dangerouslySetInnerHTML={{
                    __html: tour.tourShortDescription,
                  }}></p>
              </div>
            )}
            <table class="table">
              <tbody>
                {/* Booking Status  */}
                <tr>
                  <td><strong>Booking Status</strong></td>
                  <td>{getStatus(tour.bookingStatus)}</td>
                </tr>

                {/* Tour Date  */}
                <tr>
                  <td><strong>Travel Date</strong></td>
                  <td>{formatDate(tour.journeyDate, "DD MMM YYYY")}</td>
                </tr>

                {/* Last Vouchered Date */}
                {tour.bookingStatus === 3 && tour.apikey === "EXT" && (
                  <tr>
                    <td><strong>Last Voucher Date</strong></td>
                    {/* <td>{formatDate(dayjs(tour.journeyDate, "YYYY-MM-DD").subtract(4, 'days'), "ddd DD MMM YYYY")}</td> */}
                  <td>
                      {dayjs(tour.journeyDate).diff(dayjs(), 'days') >= 4
                        ? formatDate(dayjs(tour.journeyDate).subtract(4, 'days'), "ddd DD MMM YYYY")
                        : "Non-refundable"}
                  </td>
                  </tr>
                )}

                {/* <!-- Last Cancellation Date --> */}
                {tour.bookingStatus === 11 && tour.apikey === "EXT" && (
                  <tr>
                    <td><strong>Last Cancellation Date</strong></td>
                    {/* <td>{formatDate(dayjs(tour.journeyDate, "YYYY-MM-DD").subtract(4, 'days'), "ddd DD MMM YYYY")}</td> */}
                    <td>
                      {dayjs(tour.journeyDate).diff(dayjs(), 'days') >= 4
                        ? formatDate(dayjs(tour.journeyDate).subtract(4, 'days'), "ddd DD MMM YYYY")
                        : "Non-refundable"}
                    </td>
                  </tr>
                )}

                {/* <!-- Transfer Option --> */}
                <tr>
                  <td><strong>Transfer Option</strong></td>
                  <td>{tour.transferName}</td>
                </tr>

                {/* <!-- Duration --> */}
                {tour.duration !== "" && tour.apikey !== "EXT" && tour.transferName !== "Private Transfer" && (
                  <tr>
                    <td><strong>Duration</strong></td>
                    <td>{tour.duration}</td>
                  </tr>
                )}

                {/* <!-- Start Time --> */}
                {/* {(tour.startTime === "" || tour.startTime === 0) ? (
                  <tr>
                    <td><strong>{tour.transferName === "Private Transfers" ? "Pickup time" : "Start Time"}</strong></td>
                    <td>To be Advised</td>
                  </tr>
                ) : (
                  <tr>
                    <td><strong>{tour.transferName === "Private Transfers" ? "Pickup time" : "Start Time"}</strong></td>
                    <td>{tour.startTime}</td>
                  </tr>
                )} */}

                {/* Slot For Each QrCode by Karthik --Start Here */}
                {/* {tour.hasOwnProperty('ticket') && tour?.ticket.length > 0 && tour?.ticket?.timeSlot != '' ? (
                  <tr>
                    <td><strong>Slot </strong></td>
                    <td>{tour?.ticket?.map((ticket) => ticket?.timeSlot).join(', ')}</td>
                  </tr>
                ) : (
                  <tr>
                    <td><strong>{tour.transferName === "Private Transfers" ? "Pickup time" : "Start Time"}</strong></td>
                    <td>{tour.startTime}</td>
                  </tr>
                )} */}
                 {tour.timeSlotId != '0' ? (
                  <tr>
                    <td><strong>Slot </strong></td>
                    <td>{tour?.startTime}</td>
                  </tr>
                ) : (
                  <tr>
                    <td><strong>{tour.transferName === "Private Transfers" ? "Pickup Time" : "Start Time"}</strong></td>
                    <td>{tour.startTime}</td>
                  </tr>
                )}
                {/* {tour?.finishTime &&
                  (<tr>
                    <td><strong>{tour.transferName === "Private Transfers" ? "Dropoff time" : "Drop Time"}</strong></td>
                    <td>{tour.finishTime}</td>
                  </tr>
                  )} */}
                
                {/* Slot For Each QrCode by Karthik --End Here */}

                {/* <!-- Pickup --> */}
                {/* {tour.pickup !== "" && (
                  <tr>
                    <td><strong>{tour.transferName === "Private Transfers" ? "Pick/Drop Location" : "PickUp"}</strong></td>
                    <td>{tour.pickup}</td>
                  </tr>
                )} */}
                {tour.pickup !== "" && (
                  <tr>
                    <td>
                      <strong>
                        {tour.tourName.includes("Pick Up") ? "Drop off Location" : "Pickup Location"}
                      </strong>
                    </td>
                    <td>{tour.pickup}</td>
                  </tr>
                )}
                 {/* {tour?.dropoff  && (
                  <tr>
                    <td>
                      <strong>
                        {tour.tourName.includes("Drop Off") ? "Pick Up Location" : "Pick Up Location"}
                        Drop off Location
                      </strong>
                    </td>
                    <td>{tour.dropoff}</td>
                  </tr>
                )} */}
                {tour?.tourName?.toLowerCase().match(/\b(day|driver|taxi|car|point)\b/) &&
                  tour?.dropoff && tour?.dropoff.trim() !== "" && (
                    <tr>
                      <td><strong>Drop off Location</strong></td>
                      <td>{tour.dropoff}</td>
                    </tr>
                  )}
                
                {/* <!-- Number Of Passengers --> */}
                <tr>
                  <td><strong>Number Of Passengers</strong></td>
                  <td>{getPaxCount(tour.pax)}</td>
                </tr>

                {/* <!-- Flight and Luggage Info --> */}
                {!(tour?.TransferObj == undefined || Object.keys(tour?.TransferObj).length == 0) && tour?.TransferObj?.FlightName !== null && tour?.TransferObj?.FlightNo !== null && (
                  <>
                    <tr>
                      <td><strong>Check-In Luggage</strong></td>
                      <td>23 Kg/per X {tour?.TransferObj?.CheckLuggages} Pax</td>
                    </tr>
                    <tr>
                      <td><strong>Hand Luggage</strong></td>
                      <td>7 Kg/per X {tour?.TransferObj?.Handluggage} Pax</td>
                    </tr>
                    <tr>
                      <td><strong>Flight/Train Name</strong></td>
                      <td>{tour?.TransferObj?.FlightName}</td>
                    </tr>
                    <tr>
                      <td><strong>Flight/Train Number</strong></td>
                      <td>{tour?.TransferObj?.FlightNo}</td>
                    </tr>
                  </>
                )}

                {/* <!-- Amount --> */}
                {/* <tr>
                  <td><strong>Amount</strong></td>
                  <td>{activeCurrency} {currencyValue(Number(tour.serviceTotal).toFixed(2))}</td>
                </tr> */}

                {/* <!-- Policy --> */}
                {/* <tr>
                  <td><strong>Policy</strong></td>
                  <td>
                    <p class="wt-activity2 mt-3 btn-link" onClick={() => getTicketPolicy(tour)} style={{ cursor: "pointer", textDecoration: "none", color: "#0056b3", textAlign: "left" }}>
                      View Cancellation Policy
                    </p>
                  </td>
                </tr> */}
              </tbody>
            </table>

            {showTicketPolicyBottom && !(tour.apikey === "EXT" || tour.transferName === "Private Transfer"
             ) && (
            <div class="alert alert-info" role="alert">
                <span
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    color: "#274581",
                  }}
                >
                  Cancellation Policy:
                </span> <br />
              <p className="hotel-list-para" style={{
                  display: "inline",
                  color: "red",
                  textAlign: "justify",
                  whiteSpace: "normal",
                  wordBreak: "break-word"
                }}>
                {tour.ticketPolicy[0]?.cancellationPolicyDescription?.replace(
                  /<[^>]*>?/gm,
                  ""
                ).replace(/&nbsp;/g, " ")}
               </p>
            </div>
             )}
            {/* <div className="qr-code row justify-content-between container-fluid">
              {tour.hasOwnProperty('ticket') && tour.ticket.length > 0 && (
                <React.Fragment>
                  {tour.ticket.map((x, i) => (
                    <QRCode className="col-md-3 m-3"
                      value={x.barcode}
                      size={100}
                      title={tour.tourName}
                      id={"packageQR" + index + "" + i}
                    />
                  ))}
                </React.Fragment>
              )}
            </div> */}
          </div>
        </div>
      ))}
      {/* Canelation Policy Modal */}
      <Modal
        title={[
          <div>
            <h6 style={{ marginBottom: "0px" }}>
              <strong>Tour Cancellation Policy</strong>
            </h6>
          </div>,
        ]}
        centered
        width={1000}
        visible={CancellationPolicyModal}
        onCancel={toggleCancelHandler}
        footer={[]}
      >
        <Collapse defaultActiveKey={["1"]}>
          <Panel header="Booking Policy" key="1">
            <h5>Cancellation Policy</h5>
            {/* <p>{CancellationPolicy[0]?.cancellationPolicy} {CancellationPolicy.length == 0 && "To obtain information regarding our cancellation policy, kindly reach out to our support team"}</p> */}
            {/* <p>
                {CancellationPolicy.length > 0 ? (
                  CancellationPolicy[0]?.cancellationPolicy
                ) : (
                  <span
                    style={{ cursor: "pointer", color: "#0056b3", textDecoration: "underline" }}
                    onClick={() => window.open("/EXTPolicy/IMPORTANT NOTE.pdf", "_blank")}
                  >
                    View Cancellation Policy (PDF)
                  </span>
                )}
              </p> */}
            <pre>
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    CancellationPolicy[0]?.cancellationPolicyDescription,
                }}
              ></div>
            </pre>
            <h5>Child Policy</h5>
            <pre>
              <div
                dangerouslySetInnerHTML={{
                  __html: CancellationPolicy[0]?.childPolicyDescription,
                }}
              ></div>
            </pre>
          </Panel>
        </Collapse>
      </Modal>
      <Modal
        visible={pdfModalVisible}
        centered
        width="900px"
        height="1200px"
        style={{ top: 30 }}     // Optional: reduce top margin
        bodyStyle={{height: "48vh", padding: 0, margin: 0,}}
        onCancel={() => setPdfModalVisible(false)}
        footer={null}
        title="Tour Cancellation Policy"
      >
        <iframe
          src="/EXTPolicy/IMPORTANT%20NOTE.pdf"
          width="100%"
          height="100%"
          style={{ border: "none" }}
          title="Cancellation Policy PDF"
        />
      </Modal>
      {/* Dynamic QR Code Modal */}
      {/* <Modal title={<span>ALL QR Code Generated <QrcodeOutlined /></span>} visible={isVisible} onOk={handleOkQRModal} onCancel={handleOkQRModal}>
        <React.Fragment>
          <Row>
            <Col md={24} className="my-3">
              <Select style={{ width: 300 }} onChange={handleOnChange} defaultValue={QrCodeIndex}>
                {[...Array((Object.keys(QrCodeDetails.tour).length > 0 || QrCodeDetails.tour.hasOwnProperty('ticket').length > 0) ? QrCodeDetails?.tour?.ticket.length : 0)].map((_, count) => (
                  <Option key={"QrCode" + count} value={count}> {count + 1}</Option>
                ))}
              </Select>
            </Col>
          </Row>
          <Row>
            <Col className="my-3 mx-auto" md={12}>
              <QRCode
                value={(Object.keys(QrCodeDetails.tour).length > 0 || QrCodeDetails.tour.hasOwnProperty('ticket').length > 0) ? QrCodeDetails?.tour?.ticket[QrCodeIndex]?.barcode : ''}
                size={100}
                title={QrCodeDetails?.tour?.tourName}
                id={"packageQR" + QrCodeDetails.tourIndex + "" + QrCodeIndex}
              />
            </Col>
          </Row>
        </React.Fragment>
      </Modal> */}

      {/* my model */}

      {/* <Modal title={<span>ALL QR Code Generated <QrcodeOutlined /></span>} visible={isVisible} onOk={handleOkQRModal} onCancel={handleOkQRModal}>
        <React.Fragment>
          <Row>
            <Col md={24} className="my-3">
              <Select style={{ width: 300 }} onChange={handleOnChange} defaultValue={QrCodeIndex}>
                {[...Array((Object.keys(QrCodeDetails.tour).length > 0 || QrCodeDetails.tour.hasOwnProperty('ticket').length > 0) ? QrCodeDetails?.tour?.ticket.length : 0)].map((_, count) => (
                  <Option key={"QrCode" + count} value={count}> {count + 1}</Option>
                ))}
              </Select>
            </Col>
          </Row>
          <Row>
            <Col className="my-3 mx-auto" md={12}>
              <QRCode
                value={(Object.keys(QrCodeDetails.tour).length > 0 || QrCodeDetails.tour.hasOwnProperty('ticket').length > 0) ? QrCodeDetails?.tour?.ticket[QrCodeIndex]?.barcode : ''}
                size={100}
                title={QrCodeDetails?.tour?.tourName}
                id={"packageQR" + QrCodeDetails.tourIndex + "" + QrCodeIndex}
              />
            </Col>
          </Row>
        </React.Fragment>
      </Modal> */}

      {/* <Row>
        <Col className="my-3 mx-auto" md={12}>
          <QRCode
            value={(Object.keys(QrCodeDetails.tour).length > 0 || QrCodeDetails.tour.hasOwnProperty('ticket').length > 0) ? QrCodeDetails?.tour?.ticket[0]?.barcode : ''}
            size={100}
            title={QrCodeDetails?.tour?.tourName}
            id={"packageQR00"}
          />
        </Col>
      </Row>
      <Row>
        <Col className="my-3 mx-auto" md={12}>
          <QRCode
            value={(Object.keys(QrCodeDetails.tour).length > 0 || QrCodeDetails.tour.hasOwnProperty('ticket').length > 0) ? QrCodeDetails?.tour?.ticket[1]?.barcode : ''}
            size={100}
            title={QrCodeDetails?.tour?.tourName}
            id={"packageQR01"}
          />
        </Col>
      </Row>  */}
    </div>
  )
};

export default NewTicketActivites;
